import React from 'react';
import { Text, Preset, FunctionColor } from '@lux/text';
import { Kicker } from '@lux/kicker';
import { Translate } from '@pegasus/translation';
import { useCampaignTimer } from '@browsing/hooks';
import styled from 'styled-components';
import { TextFontSize } from '@lux/core';
import { CampaignCardMiniWrapper } from '@client/components/mylounge/campaigns/components/campaign-card-mini.styles';

export interface TimeLeftProps {
    dateTill: number;
    expireCallback?: () => void;
}

const pad2 = (number: number) => `0${number}`.slice(-2);

const StyledTitle = styled.span`
    /*  Styling Specific for CampaignCardMini
        Remove When CampaignCardMini Removed     */
    ${CampaignCardMiniWrapper} & {
        font-size: ${TextFontSize.XS};
    }
`;

const StyledText = styled(Text)`
    /*  Styling Specific for CampaignCardMini
        Remove When CampaignCardMini Removed     */
    ${CampaignCardMiniWrapper} & {
        font-size: ${TextFontSize.XS};
    }
`;

const TimeLeft = ({ dateTill, expireCallback }: TimeLeftProps) => {
    const { days, hours, minutes, seconds } = useCampaignTimer(dateTill, expireCallback);

    const prefix = 'timeLeft.endsIn';

    return (
        <Kicker
            title={
                <StyledTitle>
                    <Translate message={prefix} />
                </StyledTitle>
            }
            titlePreset={Preset.XS}
        >
            <StyledText color={FunctionColor.function100} preset={Preset.M} bold translate="no">
                {days >= 1 ? (
                    <Translate
                        message="timeLeft.ticksDayHourFormatShort"
                        params={{ days, hours, minutes }}
                        html
                    />
                ) : (
                    <Translate
                        message="timeLeft.ticksTimerFormatShort"
                        params={{
                            hours,
                            minutes: pad2(minutes),
                            seconds: pad2(seconds),
                        }}
                        html
                    />
                )}
            </StyledText>
        </Kicker>
    );
};

export default TimeLeft;
